<template>
	<button type="button" class="relative shrink-0 w-24 h-24 flex items-center justify-center hover:scale-105 transition-transform">
		<div class="absolute z-10 flex flex-col items-center">
			<div class="flex justify-center items-center rounded-full w-10 h-10 bg-primary border-2 border-white">
				<PlusIcon class="w-4 h-4 stroke stroke-[3]"></PlusIcon>
			</div>
		</div>

		<!-- Phosphor icon - Image square  / raw / modified viewbox and stroke-width -->
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="38 38 180 180" class="h-full">
			<rect width="256" height="256" fill="none"/>
			<rect x="40" y="40" width="176" height="176" rx="8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
			<circle cx="96" cy="96" r="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
			<path d="M56.69,216,166.34,106.34a8,8,0,0,1,11.32,0L216,144.69" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
		</svg>
	</button>
</template>

<script lang="ts">
import { PlusIcon } from "@heroicons/vue/24/outline";

export default {
	components: { PlusIcon },
};
</script>
